/**
 * 개발 미리보기 — /audit-demo 페이지.
 * 실제 line_item 입력 → /classify-v2 호출 → EvidenceCards 표시.
 */
import React, { useState } from "react";
import EvidenceCards from "./EvidenceCards";

const API_BASE = window.location.origin.includes("localhost")
  ? "http://127.0.0.1:8765"
  : "/api/hs"; // prod proxy 경로 (있다면)

export default function AuditDemo() {
  const [lineItem, setLineItem] = useState(
    "MEN KNITTED COTTON T-SHIRT 100% COTTON",
  );
  const [chapter, setChapter] = useState("61");
  const [audit, setAudit] = useState(true);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const classify = async () => {
    setLoading(true);
    setErr(null);
    setResponse(null);
    try {
      const r = await fetch(`${API_BASE}/classify-v2`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line_item: lineItem, chapter, audit }),
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      setResponse(await r.json());
    } catch (e) {
      setErr(String(e));
    } finally {
      setLoading(false);
    }
  };

  const downloadPdf = async () => {
    try {
      const r = await fetch(`${API_BASE}/classify-v2/pdf`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line_item: lineItem, chapter, audit: true }),
      });
      if (!r.ok) throw new Error(`PDF HTTP ${r.status}`);
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `hs-audit-${response?.hs_6digit || "result"}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      alert("PDF 다운로드 실패: " + e);
    }
  };

  return (
    <div className="audit-root" style={{ minHeight: "100vh", padding: 24 }}>
      <h1
        style={{ fontSize: 22, marginBottom: 16, color: "var(--audit-text)" }}
      >
        Audit UI 데모
      </h1>

      <div className="audit-card" style={{ marginBottom: 16 }}>
        <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
          <input
            value={lineItem}
            onChange={(e) => setLineItem(e.target.value)}
            placeholder="line_item"
            style={{
              flex: 1,
              padding: "8px 12px",
              background: "var(--audit-bg)",
              color: "var(--audit-text)",
              border: "1px solid var(--audit-border)",
              borderRadius: 6,
            }}
          />
          <input
            value={chapter}
            onChange={(e) => setChapter(e.target.value)}
            placeholder="chapter"
            style={{
              width: 80,
              padding: "8px 12px",
              background: "var(--audit-bg)",
              color: "var(--audit-text)",
              border: "1px solid var(--audit-border)",
              borderRadius: 6,
            }}
          />
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: 13,
            }}
          >
            <input
              type="checkbox"
              checked={audit}
              onChange={(e) => setAudit(e.target.checked)}
            />
            audit
          </label>
          <button
            className="audit-btn audit-btn-primary"
            onClick={classify}
            disabled={loading}
          >
            {loading ? "..." : "분류하기"}
          </button>
        </div>
        {err && (
          <div style={{ color: "#d93025", fontSize: 12 }}>오류: {err}</div>
        )}
      </div>

      {response && (
        <EvidenceCards
          response={response}
          onDownloadPdf={
            response.routing?.path === "audit" ? downloadPdf : null
          }
        />
      )}
    </div>
  );
}
